export default __webpack_public_path__ + "static/media/FilmMobile.1c639b85.svg";